module.exports = __webpack_public_path__ + "img/feature-tile-icon-04.16a82ea7.svg";